import { render, staticRenderFns } from "./error.vue?vue&type=template&id=cba54d70&scoped=true&lang=pug&"
import script from "./error.vue?vue&type=script&lang=coffee&"
export * from "./error.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba54d70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksList: require('/opt/build/repo/nuxt-app/components/globals/blocks/list.vue').default})
